import { Tooltip, useTheme } from "@mui/material";

import { SparkleIcon } from "./SparkleIcon";
import { useSuggestionChip, UseSuggestionChipProps } from "./useSuggestionChip";

export type SuggestedChipProps = UseSuggestionChipProps & {
  tooltip?: string;
  size?: "small" | "medium" | "large";
};

export function SuggestedIcon({
  tooltip = "This field was filled in automatically using the AI tool. Please review and edit as needed.",
  isSuggested = false,
  // Small, because this is an adornment inside an input. It reached MUI's own
  // scale once the size stopped being emitted as a CSS keyword, and the default
  // has to say what it wants rather than inherit the largest step — `large` is
  // 35px, roughly twice the height of the text it sits beside.
  size = "small",
}: SuggestedChipProps) {
  const theme = useTheme();

  const { showSuggestionChip } = useSuggestionChip({
    isSuggested,
  });

  if (!showSuggestionChip) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <SparkleIcon
        fontSize={size}
        sx={{
          marginY: theme.spacing(0.5),
          marginRight: theme.spacing(1),
          // Matches `InfoIconTooltip`, which is the affordance this is: a hint
          // about the value beside it, not something to click. Deliberately
          // lighter than the icon colour an action would take.
          color: "action.disabled",
        }}
      />
    </Tooltip>
  );
}
